import { array, string } from 'yup'
import { safify } from '../utils/safify'

export const productFeatures = array()
  .of(string())
  .default([])
  .meta({
    label: 'What are the features of this product/service?',
    placeholder: 'Use <tab> or , to separate features',
    snippets: true,
    autoFill: true,
  })
  .transform(safify)
